import { Typography, Button } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { AppRouteURI } from "../../router/RoleBasedAccess";

export default () => {
    return (
        <div style={{ textAlign: 'center', height: '95vh', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '1rem'}}>
            <Typography variant="h4" style={{ marginBottom: '-0.5rem' }}>403 | Forbidden</Typography>
            <Typography variant="subtitle1" color="textSecondary">You do not have permission to access this page</Typography>
            <Button disableElevation variant="outlined" color="primary" size="large" style={{ marginTop: '3rem' }} component={Link} to={AppRouteURI.HOME}>Go Home</Button>
        </div>
    )
}